// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"029cf325","167":"f1c97f81","303":"101f1794","404":"d77d84a5"}[chunkId] + ".chunk.js";
};